import { AlertTriangle } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useWorkflowValidationStore } from '@/stores/workflow-validation-store';

interface DisabledNodesBannerProps {
  className?: string;
}

export const DisabledNodesBanner = ({
  className,
}: DisabledNodesBannerProps) => {
  const { unsupportedNodes } = useWorkflowValidationStore();

  if (unsupportedNodes.length === 0) return null;

  const nodeNames = [...new Set(unsupportedNodes.map((n) => n.nodeName))].join(
    ', ',
  );

  return (
    <div
      className={cn(
        'flex items-center gap-2 px-3 py-2 rounded-xl shadow-sm',
        'bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800',
        'whitespace-nowrap',
        className,
      )}
      data-testid='disabled-nodes-banner'
    >
      <AlertTriangle className='size-4 text-amber-600 dark:text-amber-400 shrink-0' />
      <span className='text-sm text-amber-800 dark:text-amber-200'>
        Disabled nodes: <span className='font-medium'>{nodeNames}</span>. Remove
        or replace them to run this workflow.
      </span>
    </div>
  );
};
